<section class="bg-half-260 bg-primary d-table w-100" id="home"
         style="background-size:cover; background-image:url('assets/3r/cover/medium-shot-woman-taking-notes.jpg');">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-heading text-center mt-4">
                    <h1 class="display-4 title-dark font-weight-bold text-white mb-3">ADMISSION COUNSELLING</h1>
                    <!--                    <p class="para-desc mx-auto text-white-50">{{detail.description}}</p>-->
                    <!--                    <div class="mt-4 pt-2">-->
                    <!--                        <a href="javascript:void(0)" class="btn btn-primary"><i class="mdi mdi-email"></i> Get-->
                    <!--                            Started</a>-->
                    <!--                    </div>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

</section>

<div class="container mt-100 mt-60 mb-5">
    <div class="row ">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h3 class="title mb-4 mt">EDUCATION AND CAREER COUNSELLORS</h3>
                <p class="text-muted   mb-0">
                    Studying abroad is not about searching the net, filling in application forms and sending them to
                    universities you have heard of. The admission is a complex process involving lot of queries, issues,
                    and formalities that need to be completed and followed through to get successful admission. Getting
                    through the admission process of your chosen education institution can often be a confusing and
                    tedious process. We have the latest information on admission criteria, admission acceptance rates,
                    admission committee expectations and merit scale of almost all prominent colleges.
                    <br>
                    At 3R International , we help to make your admission process easier. 3R International assist
                    students in completing applications and ensuring all documentation is complete for admissions. We
                    also coordinate with the institution admission office on your behalf to ensure admission by proper
                    followup with the institution.
                    <br>
                    Our Admission counsellors assist students in understanding and completing the highly qualitative
                    aspects of foreign university applications, statements of purpose, resumes etc.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>

    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">APPLICATION</h5>
                <p class="text-muted   mb-0">
                    We help students in completing admission application forms, review them and help them to submit it
                    to respective university on their behalf to ensure successful admission.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>

    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">RECOMMENDATIONS</h5>
                <p class="text-muted   mb-0">
                    We send recommendations to the universities highlighting your strengths and also explaining reasons
                    why you should be granted admission.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>

    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">CHOOSE THE CORRECT COLLEGE</h5>
                <p class="text-muted   mb-0">
                    Ranking does matter. If you can afford it, go to the best. Just like you choose the best software
                    company to work in, choose the best college as per your budget. With hundreds of colleges to choose
                    from you can get confused. How do you rank the colleges? Choose college wisely – see what is your
                    requirement and your pocket.
                    <br>
                    Most importantly we do not make any false promises, 'what we promise, we deliver'
                </p>
            </div>
        </div>
        <!--end col-->
    </div>


</div>
